import React from 'react';
import { FontWeights, mergeStyleSets, Text } from '@fluentui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IMailPecMail } from '../../shared/interfaces';
import AppUtilities from '../../shared/Utilities/appUtilities';

const styles = mergeStyleSets({
    subject: {
        marginBottom: 12,
        fontWeight: FontWeights.regular,
    },
    from: {
        display: 'block',
        marginTop: 20,
    },
    body: {
        display: 'block',
        marginTop: 20,
    },
    toAndDate: {
        display: 'block',
        marginTop: 5,
        fontWeight: FontWeights.light
    }
});
export interface PecMailItemCellProps {
    pecMailItem: IMailPecMail
}
type Props = PecMailItemCellProps



const PecMailItemCell: React.FunctionComponent<Props> = props => {

    // metodi per la restituzione delle icone in base allo stato
    const setMyClassesIconContainer = (statoRicevuta) => {

        if (statoRicevuta === 'Completato') {
            return ("msgCompletato")

        } else if (statoRicevuta === 'Completato con errori' || statoRicevuta === 'Non Accettata') {
            return ("msgCompletatoConErrori")

        } else if (statoRicevuta.toLowerCase() === 'in attesa') {
            return ("msgInAttesa")
        }

        if (props.pecMailItem.tipologia === 'ANOMALIA MESSAGGIO') {
            return ("anomalia")
        }
    }

    const setMyClassesIcon = (statoRicevuta) => {

        if (statoRicevuta === 'Completato') {
            return (
                <FontAwesomeIcon
                    className={'info-ricevuta fa-xs'}
                    icon={{ prefix: 'fas', iconName: 'check' }}
                />
            )

        } else if (statoRicevuta === 'Completato con errori' || statoRicevuta === 'Non Accettata') {
            return (
                <FontAwesomeIcon
                    className={'info-ricevuta fa-xs'}
                    icon={{ prefix: 'fas', iconName: 'exclamation' }}
                />
            )

        } else if (statoRicevuta.toLowerCase() === 'in attesa') {
            return (
                <FontAwesomeIcon
                    className={'info-ricevuta fa-xs'}
                    icon={{ prefix: 'fas', iconName: 'hourglass-start' }}
                />
            )
        }
    }

    return (
        <>
            <div className="mail-item" id={`cell-${props.pecMailItem.id}`}>

                <div className="row1">
                    <div className="info-ricevuta">
                        {(props.pecMailItem.tipologia !== 'ANOMALIA MESSAGGIO' && props.pecMailItem.statoRicevuta !== '') &&
                            <div className={setMyClassesIconContainer(props.pecMailItem.statoRicevuta)}>
                                {setMyClassesIcon(props.pecMailItem.statoRicevuta)}
                                <p className="stato-text">{props.pecMailItem.statoRicevuta}</p>
                            </div>
                        }
                        {props.pecMailItem.tipologia === 'ANOMALIA MESSAGGIO' &&
                            <div className={setMyClassesIconContainer(props.pecMailItem.statoRicevuta)}>
                                {setMyClassesIcon(props.pecMailItem.statoRicevuta)}
                                <p className="stato-text">Anomalia</p>
                            </div>
                        }
                    </div>
                </div>

                <div className="row2">

                    <Text className="mail-from" block nowrap>
                        {props.pecMailItem.from}
                    </Text>

                    <div className="mail-info-ico">
                        {
                            props.pecMailItem.hasAttachment &&
                            <FontAwesomeIcon size="lg" icon={{ prefix: 'fal', iconName: 'paperclip' }} />
                        }
                    </div >


                </div >
                <div className="row3">
                    {props.pecMailItem.subject &&
                        <Text className="mail-subject" nowrap>
                            {props.pecMailItem.subject}
                        </Text>
                    }
                    {!props.pecMailItem.subject &&
                        <Text className="mail-subject" nowrap>
                            [Nessun oggetto]
                        </Text>
                    }
                    <Text className="mail-date" nowrap>
                        {AppUtilities.FormatDate(props.pecMailItem.date.toString(), true)}
                    </Text>

                </div >
                <div className="row4">
                    {props.pecMailItem.bodyPreview &&
                        <Text className="mail-body" block nowrap>
                            {props.pecMailItem.bodyPreview}
                        </Text>
                    }
                    {!props.pecMailItem.bodyPreview &&
                        <Text className="mail-body" block nowrap>
                            [Nessun messaggio]
                        </Text>
                    }


                </div >

            </div >
        </>

    );

}
export default PecMailItemCell;

